import { createSelector } from 'reselect';
import { getNotHiddenChildren } from '../selectors/children';
import { ChildFields } from '../models/child';

const minimumNumberOfChildrenToApply = 3;

export const validateChildrenQuantity: (state: {
  children: ChildFields[];
}) => boolean = createSelector(
  getNotHiddenChildren,
  children => children.length < minimumNumberOfChildrenToApply
);

export const validateChildrenCards = createSelector(
  getNotHiddenChildren,
  (children): boolean =>
    children.some(
      ({ cardStatus: { isCardCompleted } }): boolean => !isCardCompleted
    )
);

export const validateChildren = createSelector(
  validateChildrenQuantity,
  validateChildrenCards,
  (quantity, cards): boolean => {
    return quantity || cards;
  }
);

export const getChildrenError = (errors): string => {
  for (const key in errors) {
    if (errors.hasOwnProperty(key) && errors[key].error) {
      return key;
    }
  }
  return '';
};
